module.exports = __webpack_public_path__ + "img/b3.7711b747.jpg";